import Vue from 'vue'
import Vuex from 'vuex'
import { acknowledgement } from './modules/acknowledgement'
import { airtable } from './modules/airtable'
import { clearance } from './modules/clearance'
import { curriculum } from './modules/curriculum'
import { email } from './modules/email'
import { employee } from './modules/employee'
import { session } from './modules/session'
import { shortLink } from './modules/shortLink'
import { test } from './modules/test'
import { snackbar } from './modules/snackbar'
import { user } from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loadingApp: true,
    showNav: true,
  },
  mutations: {
    setLoadingApp (state, payload) {
      state.loadingApp = payload
    },
    setShowNav (state, payload) {
      state.showNav = payload
    },
  },
  actions: {
    setLoadingApp ({ commit }, payload) {
      return commit('setLoadingApp', payload)
    },
    setShowNav ({ commit }, payload) {
      return commit('setShowNav', payload)
    },
  },
  getters: {
    getLoadingApp (state) {
      return state.loadingApp
    },
    getShowNav (state) {
      return state.showNav
    },
  },
  modules: {
    acknowledgement,
    airtable,
    clearance,
    curriculum,
    test,
    employee,
    email,
    session,
    shortLink,
    snackbar,
    user
  }
})
